"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidName = void 0;
const constants_1 = require("../../constants");
const is_string_1 = require("../is-string/is-string");
/**
 * Validates the name of a member.
 * @public
 *
 * @param arg - The name to validate.
 *
 * @returns True if the name is valid, false otherwise.
 *
 * @example
 * ```ts
 * isValidName('John Doe'); // -> true
 * ```
 */
function isValidName(arg) {
    return (0, is_string_1.isString)(arg) && constants_1.NAME_REGEX.test(arg);
}
exports.isValidName = isValidName;
//# sourceMappingURL=is-valid-name.js.map